import { Route } from "src/types";
import {
  DataEntryWrapper,
  Error404,
  SignatureB,
  SignatureResult,
} from "src/ui/pages";
import { ManagerRoute } from "src/ui/roots/manager-root/manager-root";

export const Paths: Record<string, string> = {
  Landing: "/",
  DataEntry1: "/inserimento-dati-veicolo-a",
  DataEntry2: "/inserimento-dati-veicolo-b",
  DataEntry3: "/inserimento-dati-incidente",
  DataEntry4: "/firma-conducente-a",
  DataEntry5: "/firma-conducente-b",
  SignatureResult: "/esito-firma",
  Error404: "*",
};

export const Routes: Record<keyof typeof Paths, Route> = {
  Landing: {
    path: Paths.Landing,
    element: <ManagerRoute />,
    private: false,
  },
  DataEntry1: {
    path: Paths.DataEntry1,
    element: <DataEntryWrapper />,
    private: true,
  },
  DataEntry2: {
    path: Paths.DataEntry2,
    element: <DataEntryWrapper />,
    private: true,
  },
  DataEntry3: {
    path: Paths.DataEntry3,
    element: <DataEntryWrapper />,
    private: true,
  },
  DataEntry4: {
    path: Paths.DataEntry4,
    element: <DataEntryWrapper />,
    private: true,
  },
  DataEntry5: {
    path: Paths.DataEntry5,
    element: <SignatureB />,
    private: true,
  },
  SignatureResult: {
    path: Paths.SignatureResult,
    element: <SignatureResult />,
    private: false,
  },
  Error404: {
    path: Paths.Error404,
    element: <Error404 />,
    private: false,
  },
};
